module.exports = __webpack_public_path__ + "media/images/placeholder-d1668c55bcc95500ecf1afb43c056343.png";